import getLatinized from '../lib/getLatinized';

const reviewers = [
    {
         sort: 'Gaworski Ireneusz',
         label: {
            pl: 'dr hab. Ireneusz Gaworski (Uniwersytet Warszawski, Polska)',
            en: 'dr hab. Ireneusz Gaworski (Uniwersytet Warszawski, Poland)',
            de: 'Dr. habil. Ireneusz Gaworski (Uniwersytet Warszawski, Polen)'
        }
    },
    {
         sort: 'Grotek Monika',
         label: {
            pl: 'dr Monika Grotek (Uniwersytet Śląski, Polska)',
            en: 'dr Monika Grotek (Uniwersytet Śląski, Poland)',
            de: 'Dr. Monika Grotek (Uniwersytet Śląski, Polen)'
        }
    },
    {
         sort: 'Baran-Łucarz Małgorzata',
         label: {
            pl: 'dr Małgorzata Baran-Łucarz (Uniwersytet Wrocławski, Polska)',
            en: 'dr Małgorzata Baran-Łucarz (Uniwersytet Wrocławski, Poland)',
            de: 'Dr. Małgorzata Baran-Łucarz (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Jędrzejowski Łukasz',
         label: {
            pl: 'dr Łukasz Jędrzejowski (Universität zu Köln, Niemcy)',
            en: 'dr Łukasz Jędrzejowski (Universität zu Köln, Germany)',
            de: 'Dr. Łukasz Jędrzejowski (Universität zu Köln, Deutschland)'
        }
    },
    {
         sort: 'Just Anna',
         label: {
            pl: 'dr hab. Anna Just, prof. UW (Uniwersytet Warszawski, Polska)',
            en: 'prof. dr hab. Anna Just (Uniwersytet Warszawski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Anna Just (Uniwersytet Warszawski, Polen)'
        }
    },
    {
         sort: 'Klockmann Heidi Elisabeth',
         label: {
            pl: 'prof. Heidi Elisabeth Klockmann (Universitetet i Agder, Norwegia)',
            en: 'prof. Heidi Elisabeth Klockmann (Universitetet i Agder, Norway)',
            de: 'Prof. Assoc. Heidi Elisabeth Klockmann (Universitetet i Agder, Norwegen)'
        }
    },
    {
         sort: 'Morciniec Norbert',
         label: {
            pl: 'prof. dr hab. Norbert Morciniec (Uniwersytet Wrocławski, Polska)',
            en: 'prof. dr hab. Norbert Morciniec (Uniwersytet Wrocławski, Poland)',
            de: 'Prof. Dr. habil. Norbert Morciniec (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Ruda Marta',
         label: {
            pl: 'dr Marta Ruda (Uniwersytet Jagielloński w Krakowie, Polska)',
            en: 'dr Marta Ruda (Uniwersytet Jagielloński w Krakowie, Poland)',
            de: 'Dr. Marta Ruda (Uniwersytet Jagielloński w Krakowie, Polen)'
        }
    },
    {
         sort: 'Rytel-Schwarz Danuta',
         label: {
            pl: 'prof. Danuta Rytel-Schwarz (Universität Leipzig, Niemcy)',
            en: 'prof. Danuta Rytel-Schwarz (Universität Leipzig, Germany)',
            de: 'Univ.-Prof. Dr. habil. Danuta Rytel-Schwarz (Universität Leipzig, Deutschland)'
        }
    },
    {
         sort: 'Schatte Czesława',
         label: {
            pl: 'prof. Czesława Schatte (Uniwersytet im. Adama Mickiewicza w Poznaniu, Poland)',
            en: 'prof. Czesława Schatte (Uniwersytet im. Adama Mickiewicza w Poznaniu, Poland)',
            de: 'Univ.-Prof. Dr. habil. Czesława Schatte (Uniwersytet im. Adama Mickiewicza w Poznaniu, Polen)'
        }
    },
    {
         sort: 'Szczepaniak Jacek',
         label: {
            pl: 'dr hab. Jacek Szczepaniak, prof. ucz. (Uniwersytet Kazimierza Wielkiego w Bydgoszczy, Polska)',
            en: 'dr hab. Jacek Szczepaniak, prof. ucz. (Uniwersytet Kazimierza Wielkiego w Bydgoszczy, Poland)',
            de: 'Univ.-Prof. Dr. habil. Jacek Szczepaniak (Uniwersytet Kazimierza Wielkiego w Bydgoszczy, Polen)'
        }
    },
    {
         sort: 'Szczesniak Konrad',
         label: {
            pl: 'dr hab. Konrad Szczesniak, prof. UŚ (Uniwersytet Śląski, Polska)',
            en: 'dr hab. Konrad Szczesniak, prof. UŚ (Uniwersytet Śląski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Konrad Szczesniak (Uniwersytet Śląski, Polen)'
        }
    },
    {
         sort: 'Taborek Janusz',
         label: {
            pl: 'prof. dr hab. Janusz Taborek (Uniwersytet im. Adama Mickiewicza w Poznaniu, Polska)',
            en: 'prof. dr hab. Janusz Taborek (Uniwersytet im. Adama Mickiewicza w Poznaniu, Poland)',
            de: 'Prof. Dr. habil. Janusz Taborek (Uniwersytet im. Adama Mickiewicza w Poznaniu, Polen)'
        }
    },
    {
         sort: 'Vinckel-Roisin Hélène',
         label: {
            pl: 'prof. dr hab. Hélène Vinckel-Roisin (Université de Lorraine, Francja)',
            en: 'prof. dr hab. Hélène Vinckel-Roisin (Université de Lorraine, France)',
            de: 'Prof. Dr. habil. Hélène Vinckel-Roisin (Université de Lorraine, Frankreich)'
        }
    },
    {
         sort: 'Woźny Jacek',
         label: {
            pl: 'dr Jacek Woźny (Uniwersytet Wrocławski, Polska)',
            en: 'dr Jacek Woźny (Uniwersytet Wrocławski, Poland)',
            de: 'Dr. Jacek Woźny (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Gattnar Anja',
         label: {
            pl: 'dr Anja Gattnar (Universität Tübingen, Niemcy)',
            en: 'dr Anja Gattnar (Universität Tübingen, Germany)',
            de: 'Dr. Anja Gattnar (Universität Tübingen, Deutschland)'
        }
    },
    {
         sort: 'Szawerna Michał',
         label: {
            pl: 'dr hab. Michał Szawerna, prof. UWr (Uniwersytet Wrocławski, Polska)',
            en: 'dr hab. Michał Szawerna, prof. UWr (Uniwersytet Wrocławski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Michał Szawerna (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Szurawitzki Michael',
         label: {
            pl: 'prof. dr hab. Michael Szurawitzki (Brandenburgische Technische Universität Cottbus-Senftenberg, Niemcy)',
            en: 'prof. dr hab. Michael Szurawitzki (Brandenburgische Technische Universität Cottbus-Senftenberg, Germany)',
            de: 'Prof. Dr. phil. habil. Michael Szurawitzki (Brandenburgische Technische Universität Cottbus-Senftenberg, Deutschland)'
        }
    },
    {
         sort: 'Bąk Paweł',
         label: {
            pl: 'dr hab. Paweł Bąk, prof. UR (Uniwersytet Rzeszowski, Polska)',
            en: 'dr hab. Paweł Bąk, prof. UR (Uniwersytet Rzeszowski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Paweł Bąk (Uniwersytet Rzeszowski, Polen)'
        }
    },
    {
         sort: 'Biernacka Michalina',
         label: {
            pl: 'dr Michalina Biernacka (Uniwersytet Łódzki, Polska)',
            en: 'dr Michalina Biernacka (Uniwersytet Łódzki, Poland)',
            de: 'Dr. Michalina Biernacka (Uniwersytet Łódzki, Polen)'
        }
    },
    {
         sort: 'Czura Anna',
         label: {
            pl: 'dr Anna Czura (Uniwersytet Wrocławski, Polska)',
            en: 'dr Anna Czura (Uniwersytet Wrocławski, Poland)',
            de: 'Dr. Anna Czura (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Dargiewicz Anna',
         label: {
            pl: 'dr hab. Anna Dargiewicz, prof. UWM (Uniwersytet Warmińsko-Mazurski w Olsztynie, Polska)',
            en: 'dr hab. Anna Dargiewicz, prof. UWM (Uniwersytet Warmińsko-Mazurski w Olsztynie, Poland)',
            de: 'Univ.-Prof. Dr. habil. Anna Dargiewicz (Uniwersytet Warmińsko-Mazurski w Olsztynie, Polen)'
        }
    },
    {
         sort: 'Feret Andrzej S.',
         label: {
            pl: 'dr hab. Andrzej S. Feret, prof. UJ (Uniwersytet Jagielloński w Krakowie, Polska)',
            en: 'dr hab. Andrzej S. Feret, prof. UJ (Uniwersytet Jagielloński w Krakowie, Poland)',
            de: 'Univ.-Prof. Dr. habil. Andrzej S. Feret (Uniwersytet Jagielloński w Krakowie, Polen)'
        }
    },
    {
         sort: 'Frączek Agnieszka',
         label: {
            pl: 'dr hab. Agnieszka Frączek (Uniwersytet Warszawski, Polska)',
            en: 'dr hab. Agnieszka Frączek (Uniwersytet Warszawski, Poland)',
            de: 'Dr. habil. Agnieszka Frączek (Uniwersytet Warszawski, Polen)'
        }
    },
    {
         sort: 'Grzeszczakowska-Pawlikowska Beata',
         label: {
            pl: 'dr hab. Beata Grzeszczakowska-Pawlikowska, prof. UŁ (Uniwersytet Łódzki, Polska)',
            en: 'dr hab. Beata Grzeszczakowska-Pawlikowska, prof. UŁ (Uniwersytet Łódzki, Poland)',
            de: 'Univ.-Prof. Dr. habil. Beata Grzeszczakowska-Pawlikowska (Uniwersytet Łódzki, Polen)'
        }
    },
    {
         sort: 'Guder Andreas',
         label: {
            pl: 'prof. dr Andreas Guder (Freie Universität Berlin, Niemcy)',
            en: 'prof. dr Andreas Guder (Freie Universität Berlin, Germany)',
            de: 'Prof. Dr. phil. Andreas Guder (Freie Universität Berlin, Deutschland)'
        }
    },
    {
         sort: 'Hanus Anna',
         label: {
            pl: 'dr hab. Anna Hanus, prof. UR (Uniwersytet Rzeszowski, Polska)',
            en: 'dr hab. Anna Hanus, prof. UR (Uniwersytet Rzeszowski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Anna Hanus (Uniwersytet Rzeszowski, Polen)'
        }
    },
    {
         sort: 'Koponen Eino',
         label: {
            pl: 'prof. dr Eino Koponen (University of Turku, Finlandia)',
            en: 'prof. dr Eino Koponen (University of Turku, Finland)',
            de: 'Prof. Dr. Eino Koponen (University of Turku, Finland)'
        }
    },
    {
         sort: 'Jarosz Józef',
         label: {
            pl: 'dr hab. Józef Jarosz, prof. UWr (Uniwersytet Wrocławski, Polska)',
            en: 'dr hab. Józef Jarosz, prof. UWr (Uniwersytet Wrocławski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Józef Jarosz (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Komenda-Earle Barbara',
         label: {
            pl: 'dr hab. Barbara Komenda-Earle, prof. US (Uniwersytet Szczeciński, Polska)',
            en: 'dr hab. Barbara Komenda-Earle, prof. US (Uniwersytet Szczeciński, Poland)',
            de: 'Univ.-Prof. Dr. habil. Barbara Komenda-Earle (Uniwersytet Szczeciński, Polen)'
        }
    },
    {
         sort: 'Korycińska-Wegner Małgorzata',
         label: {
            pl: 'dr Małgorzata Korycińska-Wegner (Uniwersytet im. Adama Mickiewicza w Poznaniu, Polska)',
            en: 'dr Małgorzata Korycińska-Wegner (Uniwersytet im. Adama Mickiewicza w Poznaniu, Poland)',
            de: 'Dr. Małgorzata Korycińska-Wegner (Uniwersytet im. Adama Mickiewicza w Poznaniu, Polen)'
        }
    },
    {
         sort: 'Malicka-Kleparska Anna',
         label: {
            pl: 'prof. dr hab. Anna Malicka-Kleparska (Katolicki Uniwersytet Lubelski Jana Pawła II, Polska)',
            en: 'prof. dr hab. Anna Malicka-Kleparska (Katolicki Uniwersytet Lubelski Jana Pawła II, Poland)',
            de: 'Prof. Dr. habil. Anna Malicka-Kleparska (Katolicki Uniwersytet Lubelski Jana Pawła II, Polen)'
        }
    },
    {
         sort: 'Martyniuk Waldemar',
         label: {
            pl: 'dr hab. Waldemar Martyniuk, prof. UJ (Uniwersytet Jagielloński w Krakowie, Polska)',
            en: 'dr hab. Waldemar Martyniuk, prof. UJ (Uniwersytet Jagielloński w Krakowie, Poland)',
            de: 'Univ.-Prof. Dr. habil. Waldemar Martyniuk (Uniwersytet Jagielloński w Krakowie, Polen)'
        }
    },
    {
         sort: 'Mystkowska-Wiertelak Anna',
         label: {
            pl: 'dr hab. Anna Mystkowska-Wiertelak, prof. UWr (Uniwersytet Wrocławski, Polska)',
            en: 'dr hab. Anna Mystkowska-Wiertelak, prof. UWr (Uniwersytet Wrocławski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Anna Mystkowska-Wiertelak (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Opiłowski Roman',
         label: {
            pl: 'prof. dr hab. Roman Opiłowski (Uniwersytet Wrocławski, Polska)',
            en: 'prof. dr hab. Roman Opiłowski (Uniwersytet Wrocławski, Poland)',
            de: 'Prof. Dr. habil. Roman Opiłowski (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Pchelintseva Olena',
         label: {
            pl: 'dr Olena Pchelintseva (Johannes Gutenberg-Universität Mainz, Niemcy)',
            en: 'dr Olena Pchelintseva (Johannes Gutenberg-Universität Mainz, Germany)',
            de: 'Dr. Olena Pchelintseva (Johannes Gutenberg-Universität Mainz, Deutschland)'
        }
    },
    {
         sort: 'Pelka Daniela',
         label: {
            pl: 'dr hab. Daniela Pelka, prof. UO (Uniwersytet Opolski, Polska)',
            en: 'dr hab. Daniela Pelka, prof. UO (Uniwersytet Opolski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Daniela Pelka (Uniwersytet Opolski, Polen)'
        }
    },
    {
         sort: 'Piechurska-Kuciel Ewa',
         label: {
            pl: 'prof. dr hab. Ewa Piechurska-Kuciel (Uniwersytet Opolski, Polska)',
            en: 'prof. dr hab. Ewa Piechurska-Kuciel (Uniwersytet Opolski, Poland)',
            de: 'Prof. Dr. habil. Ewa Piechurska-Kuciel (Uniwersytet Opolski, Polen)'
        }
    },
    {
         sort: 'Poznańska Agnieszka',
         label: {
            pl: 'dr Agnieszka Poznańska (Uniwersytet Wrocławski, Polska)',
            en: 'dr Agnieszka Poznańska (Uniwersytet Wrocławski, Poland)',
            de: 'Dr. Agnieszka Poznańska (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Rejter Artur',
         label: {
            pl: 'prof. dr hab. Artur Rejter (Uniwersytet Śląski w Katowicach, Polska)',
            en: 'prof. dr hab. Artur Rejter (Uniwersytet Śląski w Katowicach, Poland)',
            de: 'Prof. Dr. habil. Artur Rejter (Uniwersytet Śląski w Katowicach, Polen)'
        }
    },
    {
         sort: 'Schäfer Florian',
         label: {
            pl: 'dr Florian Schäfer (Humboldt-Universität zu Berlin, Niemcy)',
            en: 'dr Florian Schäfer (Humboldt-Universität zu Berlin, Germany)',
            de: 'Dr. Florian Schäfer (Humboldt-Universität zu Berlin, Deutschland)'
        }
    },
    {
         sort: 'Shagal Ksenia',
         label: {
            pl: 'dr Ksenia Shagal (University of Helsinki, Finlandia)',
            en: 'dr Ksenia Shagal (University of Helsinki, Finlandia)',
            de: 'Dr. Ksenia Shagal (University of Helsinki, Finland)'
        }
    },
    {
         sort: 'Siemes Annette',
         label: {
            pl: 'dr hab. Annette Siemes, prof. UWr (Uniwersytet Wrocławski, Polska)',
            en: 'dr hab. Annette Siemes, prof. UWr (Uniwersytet Wrocławski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Annette Siemes (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Smykała Marta',
         label: {
            pl: 'dr hab. Marta Smykała, prof. UR (Uniwersytet Rzeszowski, Polska)',
            en: 'dr hab. Marta Smykała, prof. UR (Uniwersytet Rzeszowski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Marta Smykała (Uniwersytet Rzeszowski, Polen)'
        }
    },
    {
         sort: 'Szpyra-Kozłowska Jolanta',
         label: {
            pl: 'prof. dr hab. Jolanta Szpyra-Kozłowska (Uniwersytet Marii Curie-Skłodowskiej, Polska)',
            en: 'prof. dr hab. Jolanta Szpyra-Kozłowska (Uniwersytet Marii Curie-Skłodowskiej, Poland)',
            de: 'Prof. Dr. habil. Jolanta Szpyra-Kozłowska (Uniwersytet Marii Curie-Skłodowskiej, Polen)'
        }
    },
    {
         sort: 'Szubert Andrzej',
         label: {
            pl: 'dr hab. Andrzej Szubert, prof. UAM (Uniwersytet im. Adama Mickiewicza w Poznaniu, Polska)',
            en: 'dr hab. Andrzej Szubert, prof. UAM (Uniwersytet im. Adama Mickiewicza w Poznaniu, Poland)',
            de: 'Univ.-Prof. Dr. habil. Andrzej Szubert (Uniwersytet im. Adama Mickiewicza w Poznaniu, Polen)'
        }
    },
    {
         sort: 'Szubert Rafał',
         label: {
            pl: 'dr hab. Rafał Szubert (Uniwersytet Wrocławski, Polska)',
            en: 'dr hab. Rafał Szubert (Uniwersytet Wrocławski, Poland)',
            de: 'Dr. habil. Rafał Szubert (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Tworek Artur',
         label: {
            pl: 'dr hab. Artur Tworek, prof. UWr (Uniwersytet Wrocławski, Polska)',
            en: 'dr hab. Artur Tworek, prof. UWr (Uniwersytet Wrocławski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Artur Tworek (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Walczyński Marcin',
         label: {
            pl: 'dr hab. Marcin Walczyński, prof. UWr (Uniwersytet Wrocławski, Polska)',
            en: 'dr hab. Marcin Walczyński, prof. UWr (Uniwersytet Wrocławski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Marcin Walczyński (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Ylikoski Jussi',
         label: {
            pl: 'prof. dr Jussi Ylikoski (University of Turku, Finlandia)',
            en: 'prof. dr Jussi Ylikoski (University of Turku, Finland)',
            de: 'Prof. Dr. Jussi Ylikoski (University of Turku, Finland)'
        }
    },
    {
         sort: 'Zdziebko Sławomir',
         label: {
            pl: 'dr Sławomir Zdziebko (Katolicki Uniwersytet Lubelski Jana Pawła II, Polska)',
            en: 'dr Sławomir Zdziebko (Katolicki Uniwersytet Lubelski Jana Pawła II, Poland)',
            de: 'Dr. Sławomir Zdziebko (Katolicki Uniwersytet Lubelski Jana Pawła II, Polen)'
        }
    },
    {
         sort: 'Zuchewicz Karolina',
         label: {
            pl: 'prof. dr Karolina Zuchewicz (Uniwersytet Lipski, Niemcy)',
            en: 'prof. dr Karolina Zuchewicz (Universität Leipzig, Germany)',
            de: 'Jun.-Prof. Dr. Karolina Zuchewicz (Universität Leipzig, Deutschland)'
        }
    },
    {
         sort: 'Żebrowska Ewa',
         label: {
            pl: 'prof. dr hab. Ewa Żebrowska (Uniwersytet Warszawski, Polska)',
            en: 'prof. dr hab. Ewa Żebrowska (Uniwersytet Warszawski, Poland)',
            de: 'Prof. Dr. habil. Ewa Żebrowska (Uniwersytet Warszawski, Polen)'
        }
    },
    {
         sort: 'Živojinović Jelena',
         label: {
            pl: 'dr Jelena Živojinović (Uniwersytet w Grazu, Austria)',
            en: 'dr Jelena Živojinović (Universität Graz, Austria)',
            de: 'Dr. Jelena Živojinović (Universität Graz, Österreich)'
        }
    }
].sort((a, b) =>
    getLatinized((a.sort).toLowerCase()) >
    getLatinized((b.sort).toLowerCase()) ? 1 : -1
);

export default reviewers;
